<template>
  <vs-tabs>
    <vs-tab :label="awayTeamName">
      <div class="tab-text">
        <vs-table :data="awayTeamPlayerStats" :noDataText="emptyAwayBoxscore">
          <template slot="thead">
            <vs-th>Player</vs-th>
            <vs-th>Points</vs-th>
            <vs-th>Rebounds</vs-th>
            <vs-th>Assists</vs-th>
            <vs-th>Steals</vs-th>
            <vs-th>Blocks</vs-th>
            <vs-th>Turnovers</vs-th>
            <vs-th>FGM/A</vs-th>
            <vs-th>3FGM/A</vs-th>
            <vs-th>FTM/A</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr v-for="tr in data" :key="tr.id">
              <vs-td :data="tr.id">
                <router-link :to="{ name: 'player', params: { id: tr.id } }">
                  {{ `#${tr.jersey} ${tr.firstname} ${tr.lastname}` }}
                </router-link>
              </vs-td>
              <vs-td :data="tr.points">
                {{ tr.points }}
              </vs-td>
              <vs-td :data="tr.rebounds">
                {{ tr.rebounds }}
              </vs-td>
              <vs-td :data="tr.assists">
                {{ tr.assists }}
              </vs-td>

              <vs-td :data="tr.steals">
                {{ tr.steals }}
              </vs-td>

              <vs-td :data="tr.blocks">
                {{ tr.blocks }}
              </vs-td>

              <vs-td :data="tr.turnovers">
                {{ tr.turnovers }}
              </vs-td>

              <vs-td :data="tr.fgm / tr.fga"> {{ tr.fgm }}/{{ tr.fga }} </vs-td>

              <vs-td :data="tr.fgm3 / tr.fga3">
                {{ tr.fgm3 }}/{{ tr.fga3 }}
              </vs-td>

              <vs-td :data="tr.ftm / tr.fta"> {{ tr.ftm }}/{{ tr.fta }} </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-tab>
    <vs-tab :label="homeTeamName">
      <div class="tab-text">
        <vs-table :data="homeTeamPlayerStats" :noDataText="emptyHomeBoxscore">
          <template slot="thead">
            <vs-th>Player</vs-th>
            <vs-th>Points</vs-th>
            <vs-th>Rebounds</vs-th>
            <vs-th>Assists</vs-th>
            <vs-th>Steals</vs-th>
            <vs-th>Blocks</vs-th>
            <vs-th>Turnovers</vs-th>
            <vs-th>FGM/A</vs-th>
            <vs-th>3FGM/A</vs-th>
            <vs-th>FTM/A</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="tr.id" v-for="tr in data">
              <vs-td :data="tr.id">
                <router-link :to="{ name: 'player', params: { id: tr.id } }">
                  {{ `#${tr.jersey} ${tr.firstname} ${tr.lastname}` }}
                </router-link>
              </vs-td>
              <vs-td :data="tr.points">
                {{ tr.points }}
              </vs-td>
              <vs-td :data="tr.rebounds">
                {{ tr.rebounds }}
              </vs-td>
              <vs-td :data="tr.assists">
                {{ tr.assists }}
              </vs-td>
              <vs-td :data="tr.steals">
                {{ tr.steals }}
              </vs-td>
              <vs-td :data="tr.blocks">
                {{ tr.blocks }}
              </vs-td>
              <vs-td :data="tr.turnovers">
                {{ tr.turnovers }}
              </vs-td>
              <vs-td :data="tr.fgm / tr.fga"> {{ tr.fgm }}/{{ tr.fga }} </vs-td>
              <vs-td :data="tr.fgm3 / tr.fga3">
                {{ tr.fgm3 }}/{{ tr.fga3 }}
              </vs-td>
              <vs-td :data="tr.ftm / tr.fta"> {{ tr.ftm }}/{{ tr.fta }} </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-tab>
    <vs-tab label="Play by Play">
      <div class="tab-text">
        <vx-card class="px-3" :key="play.id" v-for="play in plays">
          <vs-divider class="my-3" />
          <div v-if="play.action && play.player">
            {{ play.action }} #{{ play.player.jersey }}
            {{ play.player.firstname }}
            {{ play.player.lastname }} (<router-link
              :to="{ name: 'team', params: { id: play.player.team_id } }"
              >{{ teamName(play.player.team_id) }}</router-link
            >) in the {{ period(play.period) }}.
          </div>
          <div v-else-if="play.action && play.selected">
            {{ play.action }}
            (<router-link
              :to="{
                name: 'team',
                params: {
                  id: play.selected === 'away' ? awayTeam.id : homeTeam.id
                }
              }"
              >{{
                play.selected === "away" ? awayTeamName : homeTeamName
              }}</router-link
            >) in the {{ period(play.period) }}.
          </div>
          <vs-divider class="my-3" />
        </vx-card>
      </div>
    </vs-tab>
  </vs-tabs>
</template>
<script>
import boxscoreApi from "@/api/boxscore";
import { playerGameStats } from "@/utils/GameData";
const dateTimeFormat = new Intl.DateTimeFormat("en", {
  year: "numeric",
  month: "short",
  day: "2-digit"
});

export default {
  name: "BoxscoreListing",
  mounted() {
    if (this.id) this.loadBoxscoreGames();
  },
  props: ["id"],
  watch: {
    id() {
      if (this.id) this.loadBoxscoreGames();
    }
  },
  data() {
    return {
      game: {},
      league: {},
      homeTeam: {},
      homeTeamPlayerStats: [],
      awayTeam: {},
      awayTeamPlayerStats: [],
      court: {},
      emptyAwayBoxscore: "",
      emptyHomeBoxscore: "",
      playerStats: [],
      plays: []
    };
  },
  computed: {
    homeTeamName() {
      if (this.homeTeam && this.homeTeam.name) {
        return this.homeTeam.name;
      }

      return "Home Team";
    },
    awayTeamName() {
      if (this.awayTeam && this.awayTeam.name) {
        return this.awayTeam.name;
      }

      return "Away Team";
    },
    score() {
      return `${this.game.away_team_score || 0} - ${this.game.home_team_score ||
        0}`;
    }
  },
  methods: {
    dateFormat(d) {
      return d ? dateTimeFormat.format(new Date(d)) : d;
    },
    teamName(id) {
      if (this.awayTeam && this.awayTeam.id === id) {
        return this.awayTeam.name;
      } else if (this.homeTeam && this.homeTeam.id === id) {
        return this.homeTeam.name;
      }
    },
    period(p) {
      switch (p) {
        case "q1":
          return "first quarter";
        case "q2":
          return "second quarter";
        case "q3":
          return "third quarter";
        case "q4":
          return "fourth quarter";
        case "h1":
          return "first half";
        case "h2":
          return "second half";
        case "ot1":
          return "overtime";
        default:
          return "";
      }
    },
    async loadBoxscoreGames() {
      this.emptyAwayBoxscore = "Searching Ballstar database...";
      this.emptyHomeBoxscore = "Searching Ballstar database...";
      const {
        response: { data }
      } = await boxscoreApi.get(this.id);
      this.game = data.data.game;
      this.homeTeam = data.data.homeTeam;
      this.awayTeam = data.data.awayTeam;
      this.court = data.data.court;
      this.league = data.data.league;
      this.playerStats = data.playerStats;
      this.homeTeamPlayerStats = playerGameStats({
        players: this.homeTeam.players.filter(p => p.active),
        playerStats: data.playerStats
      }).sort((b, a) => a.points - b.points);
      this.awayTeamPlayerStats = playerGameStats({
        players: this.awayTeam.players,
        playerStats: data.playerStats
      }).sort((b, a) => a.points - b.points);
      try {
        const {
          response: { data: playData }
        } = await boxscoreApi.getPlays(this.id);
        this.plays = playData.data;
      } catch (ex) {
        console.log("ex", ex);
      }
    }
  },
  metaInfo() {
    return {
      title: `${this.awayTeamName} vs ${this.homeTeamName} ${this.dateFormat(
        this.game.game_date
      )} @ ${this.court.name}`
    };
  }
};
</script>
